import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    position: "relative",
    overflowY: "auto",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    margin: "0 auto",
    width: "calc(100vw - 64px)",
    maxWidth: 1600,
    [theme.breakpoints.down("lg")]: {
      margin: "0 20px",
      width: "calc(100vw - 40px)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      width: "calc(100vw - 24px)",
      margin: "0 12px",
    },
  },
}));
